module.exports = __webpack_public_path__ + "img/anf4.2ae2487f.png";